import { FileText } from "lucide-react";
import { ebooks } from "@/data/landingData";

const EbooksSection = () => (
  <section id="ebooks" className="py-16 sm:py-24">
    <div className="container mx-auto px-5 sm:px-4">
      <div className="text-center mb-10 sm:mb-16">
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
          <span className="text-gradient-green">Ebooks</span> e Guias
        </h2>
        <p className="text-base sm:text-xl text-muted-foreground max-w-2xl mx-auto">
          Nossos Ebooks sobre imagem e estilo de
          <span> autoria de Leonardo Hallal</span> <br className="hidden sm:block" />
          Ideais para indivíduos que buscam sua imagem mais interessante, autêntica e marcante.
          <br className="hidden sm:block" />
          Indispensáveis para Consultores de Imagem e Estilo.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-6 max-w-5xl mx-auto">
        {ebooks.map((ebook, index) => (
          <div
            key={ebook.title}
            className={`rounded-3xl p-6 sm:p-8 ${ebook.highlight ? "bg-primary text-primary-foreground border-2 border-primary shadow-glow-strong" : "bg-card border border-border/50"}`}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className={`w-14 h-14 rounded-2xl mb-4 flex items-center justify-center ${ebook.highlight ? "bg-primary-foreground/20" : "bg-primary/10"}`}>
              <FileText className={`w-7 h-7 ${ebook.highlight ? "text-primary-foreground" : "text-primary"}`} />
            </div>
            <h3 className="font-display text-lg sm:text-xl font-bold mb-3">{ebook.title}</h3>
            <p className={`mb-6 text-sm sm:text-base ${ebook.highlight ? "text-primary-foreground/80" : "text-muted-foreground"}`}>{ebook.description}</p>
            <a
              href={ebook.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-full py-3 rounded-full font-semibold transition-all hover:scale-105 inline-flex items-center justify-center ${ebook.highlight ? "bg-background text-foreground hover:bg-foreground hover:text-background" : "bg-primary text-primary-foreground"}`}
            >
              Adquirir
            </a>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default EbooksSection;
